import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  company: null,
  companyDocId: null,
  members: [],
  pendingInvites: [],
  loading: false,
  error: '',
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    companyPending: (state) => {
      state.loading = true;
      state.error = '';
    },
    companyFailed: (state, { payload }) => {
      state.loading = false;
      state.error = payload || 'Something went wrong.';
    },
    setCompanyData: (state, { payload }) => {
      state.loading = false;
      state.error = '';
      state.company = payload.company || null;
      state.companyDocId = payload.companyDocId || null;
    },
    setTeamRoster: (state, { payload }) => {
      state.loading = false;
      state.members = payload.members || [];
      state.pendingInvites = payload.pendingInvites || [];
    },
    clearCompany: () => initialState,
  },
});

export const {
  companyPending,
  companyFailed,
  setCompanyData,
  setTeamRoster,
  clearCompany,
} = companySlice.actions;

export default companySlice.reducer;
